import React from "react";
import { Stack, Typography } from "@mui/material";

import Header from "./Header.png";
import LogoBackground from "./LogoBackground.png";

import { StyledHeader, StyledWatermark } from "./styles";

const TermsPage = ({ children }) => {
  return (
    <Stack width="100%" height="100%">
      {children}
      <StyledHeader component="img" src={Header} />
      <StyledWatermark component="img" src={LogoBackground} />
    </Stack>
  );
};

export default TermsPage;
